import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/i18n";
import PageSeo from "@/components/PageSeo";
import JsonLd from "@/components/JsonLd";
import SeoFooter from "@/components/SeoFooter";
import { ABOUT, ORIGIN } from "@/data/seoPages";

const GOLD = "#C7A668";

export default function AboutPage({ lang: routeLang }) {
  const ctx = useLang();
  const lang = routeLang || ctx.lang;
  const L = (en, es) => (lang === "en" ? en : es);
  const c = ABOUT[lang];
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const canonical = ORIGIN + (lang === "en" ? ABOUT.enPath : ABOUT.esPath);

  const jsonld = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: c.title,
    description: c.desc,
    url: canonical,
    mainEntity: {
      "@type": "ProfessionalService",
      name: "dukk",
      url: ORIGIN,
      description: c.intro,
      serviceType: lang === "en" ? "Aircraft readiness, cabin care and detailing" : "Aircraft readiness, cabin care y detailing",
      areaServed: { "@type": "Country", name: "Mexico" },
      knowsLanguage: ["es-MX", "en"],
    },
  };

  return (
    <div className="grain" style={{ minHeight: "100vh", paddingTop: 110 }}>
      <PageSeo esPath={ABOUT.esPath} enPath={ABOUT.enPath} title={c.title} description={c.desc} lang={lang} image={`${ORIGIN}/og/about-${lang}.png`} />
      <JsonLd data={jsonld} id="jsonld-about" />
      <article data-testid="about-page" style={{ maxWidth: 820, margin: "0 auto", padding: "0 clamp(20px,5vw,40px)" }}>
        <div className="font-mono" style={{ fontSize: 10.5, letterSpacing: ".18em", color: GOLD, marginBottom: 14 }}>{c.kicker.toUpperCase()}</div>
        <h1 style={{ fontSize: "clamp(30px,5vw,52px)", fontWeight: 400, margin: 0, letterSpacing: "-.02em", lineHeight: 1.08 }}>{c.h1}</h1>
        <p style={{ fontSize: "clamp(16px,2vw,19px)", color: "#B8BDC3", lineHeight: 1.65, margin: "22px 0 0", maxWidth: 720 }}>{c.intro}</p>

        {c.sections.map((s, i) => (
          <section key={i} style={{ marginTop: 40 }}>
            <h2 style={{ fontSize: "clamp(20px,2.6vw,26px)", fontWeight: 400, margin: "0 0 12px", letterSpacing: "-.01em" }}>{s.h}</h2>
            <p style={{ fontSize: 16, color: "#B8BDC3", lineHeight: 1.7, margin: 0, maxWidth: 720 }}>{s.body}</p>
          </section>
        ))}

        <div style={{ marginTop: 44, display: "flex", gap: 12, flexWrap: "wrap" }}>
          <Link to={lang === "en" ? "/en/book" : "/book"} data-testid="about-cta-book" className="tb-cta" style={{ background: "#F2EFE8", color: "#0a0a0a", fontWeight: 600, borderRadius: 4, padding: "12px 22px", fontSize: 14, textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 8 }}>{L("Book service", "Reservar servicio")}<ArrowRight size={15} /></Link>
          <Link to={lang === "en" ? "/en/membership" : "/membership"} style={{ color: GOLD, border: `1px solid ${GOLD}`, borderRadius: 4, padding: "12px 22px", fontSize: 14, textDecoration: "none" }}>{L("Membership", "Membresía")}</Link>
        </div>
      </article>
      <SeoFooter />
    </div>
  );
}
